import { Action } from '@ngrx/store';
import { Invitation } from 'src/app/models/invitation';

export const GET_USER_INVITATIONS = 'GET_USER_INVITATIONS';
export const GET_USER_INVITATIONS_SUCCESS = 'GET_USER_INVITATIONS_SUCCESS';
export const GET_USER_INVITATIONS_FAILURE = 'GET_USER_INVITATIONS_FAILURE';

export const ACCEPT_USER_INVITATION = 'ACCEPT_USER_INVITATION';
export const ACCEPT_USER_INVITATION_SUCCESS = 'ACCEPT_USER_INVITATION_SUCCESS';
export const ACCEPT_USER_INVITATION_FAILURE = 'ACCEPT_USER_INVITATION_FAILURE';

export const REJECT_USER_INVITATION = 'REJECT_USER_INVITATION';
export const REJECT_USER_INVITATION_SUCCESS = 'REJECT_USER_INVITATION_SUCCESS';
export const REJECT_USER_INVITATION_FAILURE = 'REJECT_USER_INVITATION_FAILURE';

export class GetUserInvitations implements Action {
    readonly type = GET_USER_INVITATIONS;
}

export class GetUserInvitationsSuccess implements Action {
    readonly type = GET_USER_INVITATIONS_SUCCESS;
    constructor(public payload: Invitation[]) { }
}

export class GetUserInvitationsFailure implements Action {
    readonly type = GET_USER_INVITATIONS_FAILURE;
    constructor(public payload: string) { }
}

export class AcceptUserInvitation implements Action {
    readonly type = ACCEPT_USER_INVITATION;
    constructor(public payload: number) { }
}

export class AcceptUserInvitationSuccess implements Action {
    readonly type = ACCEPT_USER_INVITATION_SUCCESS;
    constructor() { }
}

export class AcceptUserInvitationFailure implements Action {
    readonly type = ACCEPT_USER_INVITATION_FAILURE;
}

export class RejectUserInvitation implements Action {
    readonly type = REJECT_USER_INVITATION;
    constructor(public payload: number) { }
}

export class RejectUserInvitationSuccess implements Action {
    readonly type = REJECT_USER_INVITATION_SUCCESS;
    constructor() { }
}

export class RejectUserInvitationFailure implements Action {
    readonly type = REJECT_USER_INVITATION_FAILURE;
}

export type InvitationsActions
    = GetUserInvitations | GetUserInvitationsSuccess | GetUserInvitationsFailure |
        AcceptUserInvitation | AcceptUserInvitationSuccess | AcceptUserInvitationFailure | 
        RejectUserInvitation | RejectUserInvitationSuccess | RejectUserInvitationFailure 